import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/exp-components';
import './style.scss';

export class HexagonImage extends React.Component {
  render() {
    const {image, id, type} = this.props;
    return <Image className='output-node' src={image} alt={`${id}_${type}`} />;
  }
}

HexagonImage.propTyeps = {
  content: PropTypes.array,
  id: PropTypes.number,
  image: PropTypes.string.isRequired,
  type: PropTypes.string,
};
